import { useEffect } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

let intervalId;

const useTokenRefresher = (refreshTime, expTime, refreshToken) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!refreshTime || !expTime || !refreshToken) return;

    const handleTokenRefresh = () => {
      const currentTime = moment().unix();

      if (currentTime >= expTime) {
        clearInterval(intervalId);

        //clear tokens
        localStorage.removeItem("access_token");
        localStorage.removeItem("Zino_app_user");
        localStorage.removeItem("zino_token");

        navigate("/login", { replace: true });
      } else if (currentTime >= refreshTime) {
        refreshToken(); // Call API to refresh token
      }
    };

    intervalId = setInterval(handleTokenRefresh, 600000); //every ten minutes check the token

    handleTokenRefresh();

    return () => {
      clearInterval(intervalId);
    };

    //eslint-disable-next-line
  }, [refreshTime, expTime, refreshToken]);
};

export default useTokenRefresher;
